import { useEffect } from "react";
import { autoPromptPush, resumePush } from "~/lib/push";

export function PushBootstrap({ askOnLoad = false }: { askOnLoad?: boolean }) {
  useEffect(() => {
    void (askOnLoad ? autoPromptPush() : resumePush());
  }, [askOnLoad]);
  return null;
}
